
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';
import { AuthService } from '../../api/auth.service';

@Component({
  selector: 'g9-sample-test',
  templateUrl: './g9-sample-test.component.html',
  styleUrls: ['./g9-sample-test.component.scss']
})
export class G9SampleTestComponent implements OnInit {

  public breadcrumb = [];

  constructor(
    public lang:LangService,
    private auth:AuthService,
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }

  ngOnInit() {
    this.loginGuard.deactivate();
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService._CURRENT( this.lang.tra('Grade 9 Mathematics Sample Assessments'), this.router.url),
    ];
    this.auth.apiCreate('public/log', {
      slug: 'G9_SAMPLE_TEST_COVER',
      data: { lang: this.lang.c() }
    })
  }

  isEnglish(){
    return (this.lang.c() === 'en');
  }
  setLang(langCode:string){
    this.lang.loadInLang(langCode);
  }
}
